import React, {
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useRef,
  useEffect,
  useState,
} from 'react';
import Image from 'next/image';
import stylesModule from './RequestDemoModal.module.less';
import { DownloadOutlined, FallOutlined, RightOutlined } from '@ant-design/icons';
import { ResponsiveModal } from './Responsivemodadal';
import { TextBlock, TextSpan } from '../../../uicomp/atmos/content-block/ContentBlock';
import Form, { SchemaFormItems } from '../../../components/form/Form';
import { Modal, Radio, Space, Alert, Button } from 'antd';
import { useConnection, useUserInfo } from '../../../connection/Application';
import moment from 'moment';
import FileUploadEx from '../../../components/FileUpload/FileUpload';
import Utils from '../../../utils/Utils';
import background from '../../../public/recruiter/recruiter-landing/demoimage.png';
import successbackground from '../../../public/recruiter/recruiter-landing/demosuccessimg.png';
import successbackgroundmob from '../../../public/recruiter/recruiter-landing/successmobile.png';

export type RequestDemoInstance = {
  show: () => void;
};

type Props = any;

const RequestDemoModal: ForwardRefRenderFunction<RequestDemoInstance, Props> = (props, ref) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [mailsent, setMailSent] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const { plan } = props;

  const styles: any = stylesModule;

  const [form] = Form.useForm();
  const connection = useConnection();

  useImperativeHandle(
    ref,
    () => ({
      show: () => {
        form.resetFields();
        setVisible(true);
        setLoading(false);
      },
    }),
    [form],
  );

  const submit = useCallback(
    (value: any) => {
      console.log('valuesubmitw', value);
      setLoading(true);
      connection
        .post('recruiter/requestdemo', {
          firstName: value.firstName,
          lastName: value.lastName,
          company: value.company,
          businessemail: value.businessemailaddress,
          contactNumber: value.contactnumber,
          reqPkg: plan,
        })
        .catch(() => {
          Modal.error({
            title: 'Error',
            content: 'An Error Ocured',
          });
        })
        .then(() => {
          console.log('sent');
        })
        .finally(() => {
          setLoading(false);
          setMailSent(true);
          //   setVisible(false);
        });
    },
    [connection, plan],
  );

  return (
    <ResponsiveModal
      width={'60vw'}
      wrapClassName={styles.hotTipsModal}
      //   title={'Request Demo'}
      open={visible}
      footer={null}
      //   onOk={() => {
      //     // submit({ quickcvUrl: cvUrl });
      //   }}
      //   confirmLoading={loading}
      //   okText={'Submit Now'}
      //   cancelText={'Cancel'}
      onCancel={() => {
        setVisible(false), setError(undefined), setMailSent(false);
      }}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Image
          //   width={100}
          //   height={100}
          className={styles.bgImage}
          style={{ width: '45%', height: 'inherit' }}
          src={mailsent ? successbackground : background}
          alt="Recruiter & Candidate"
        />
        <div
          className={styles.formContainer}
          style={
            mailsent
              ? {
                  padding: '20px 15px',
                  height: '80vh',
                  overflow: 'auto',
                  alignItems: 'center',
                  display: 'flex',
                  margin: 'auto',
                }
              : { padding: '20px 15px', height: '80vh', overflow: 'auto', margin: 'auto' }
          }>
          <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
            {mailsent && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                }}>
                <h1>Thank you for your submission!</h1>
                <p
                  style={{
                    marginTop: 0,
                    letterSpacing: ' 0.19px',
                    color: '#5B6272',
                    fontSize: '15px',
                  }}>
                  You’re one step closer to move your business to the next level. One of our experts
                  will be reaching out to you soon.
                </p>
                <Image
                  //   width={100}
                  //   height={100}
                  className={styles.bgImageMob}
                  src={successbackgroundmob}
                  alt="success image"
                />
              </div>
            )}
            {!mailsent && (
              <>
                <>{console.log(error)}</>
                <h1 style={{ marginBottom: 0, marginTop: 0 }}>Request a Demo</h1>
                <p
                  style={{
                    marginTop: 0,
                    letterSpacing: ' 0.19px',
                    color: '#5B6272',
                    fontSize: '15px',
                  }}>
                  Tell us a bit about yourself, and one of our product experts will get in touch.
                </p>

                <Form.Form
                  style={{ marginRight: '5px' }}
                  form={form}
                  layout={'vertical'}
                  onFinish={submit}>
                  <SchemaFormItems
                    schema={[
                      {
                        id: 'firstName',
                        name: 'First Name',
                        type: 'string',
                        props: {
                          placeholder: 'Enter first name',
                          //   onChange: (e: any) => {
                          //     if (e.target.value === '') {
                          //     }
                          //   },
                          // disabled: cvUrl !== '',
                        },
                        options: {
                          rules: [
                            { required: true, message: 'Please enter your First name' },
                            { max: 50, message: 'Maximum 50 characters allowed' },
                          ],
                        },
                      },
                      {
                        id: 'lastName',
                        name: 'Last Name',
                        type: 'string',
                        props: {
                          placeholder: 'Enter last name',
                          //   onChange: (e: any) => {
                          //     if (e.target.value === '') {
                          //     }
                          //   },
                          // disabled: cvUrl !== '',
                        },
                        options: {
                          rules: [
                            { required: true, message: 'Please enter your Last name' },
                            { max: 50, message: 'Maximum 50 characters allowed' },
                          ],
                        },
                      },
                      {
                        id: 'company',
                        name: 'Company',
                        type: 'string',
                        props: {
                          placeholder: 'Enter company name',
                          //   onChange: (e: any) => {
                          //     if (e.target.value === '') {
                          //     }
                          //   },
                          // disabled: cvUrl !== '',
                        },
                        options: {
                          rules: [
                            { required: true, message: 'Please enter your Company' },
                            { max: 150, message: 'Maximum 150 characters allowed' },
                          ],
                        },
                      },
                      {
                        id: 'businessemailaddress',
                        name: 'Business Email Address',
                        type: 'email',
                        props: {
                          placeholder: 'example@email.com',
                          //   onChange: (e: any) => {
                          //     if (e.target.value === '') {
                          //     }
                          //   },
                          // disabled: cvUrl !== '',
                        },
                        options: {
                          rules: [
                            { required: true, message: 'Please enter a valid Email Address' },
                            {
                              type: 'email',
                              message: 'Please enter a valid Email Address',
                            },
                          ],
                        },
                      },
                      {
                        id: 'contactnumber',
                        name: 'Contact Number',
                        type: 'phone',
                        props: {
                          placeholder: 'Enter Contact Number',
                          maxLength: 17,
                        },
                        options: {
                          rules: [
                            { required: true, message: 'Please enter your Contact number' },
                            {
                              validator: 'phone',
                              message: 'Please enter a valid Contact Number',
                            },
                          ],
                        },
                      },
                    ]}
                  />
                  <div
                    className={styles.buttonCont}
                    style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Button
                      loading={loading}
                      size={'large'}
                      type={'primary'}
                      onClick={() => {
                        form
                          .validateFields()
                          .then((values) => {
                            submit(values);
                          })
                          .catch((error) => {
                            console.log('form validation error', error);
                          });
                      }}
                      className={styles.requestDemoBtn}>
                      <b style={{ fontWeight: 'bolder', display: 'flex', alignItems: 'center' }}>
                        Request a Demo{' '}
                        <RightOutlined
                          className={styles.requestdemoicon}
                          style={{ paddingLeft: '10px' }}
                        />
                      </b>
                    </Button>
                    <span className={styles.callustext}>
                      Questions? Call us at:{' '}
                      <a href="tel:+94727360360">
                        <span style={{ color: '#009E52', whiteSpace: 'nowrap' }}>
                          +94 727 360 360
                        </span>
                      </a>
                    </span>
                  </div>
                </Form.Form>
              </>
            )}
          </div>
        </div>
      </div>
    </ResponsiveModal>

    // <ResponsiveModal
    //   // title={'Request Demo'}
    //   open={visible}
    //   footer={null}
    //   // onOk={() => {
    //   //   // submit({ quickcvUrl: cvUrl });
    //   // }}
    //   // confirmLoading={loading}
    //   // okText={'Submit Now'}
    //   // cancelText={'Cancel'}
    //   onCancel={() => {
    //     setVisible(false), setError(undefined);
    //   }}>
    //   <div style={{ width: '30%' }}>
    //     <img src="https://www.freecodecamp.org/news/content/images/2021/06/w-qjCHPZbeXCQ-unsplash.jpg" alt="your-image" style={{ maxWidth: '100%', height: 'auto' }} />
    //   </div>
    //   <div style={{ width: '70%' }}>
    //     <Form.Form
    //       form={form}
    //       layout={'vertical'}
    //       onFinish={submit}
    //       initialValues={{ linkedInUrl: user?.linkedInUrl }}>
    //       <SchemaFormItems
    //         schema={[
    //           {
    //             id: 'linkedInUrl',
    //             name: 'LinkedIn Url',
    //             type: 'url',
    //             props: {
    //               linkedin: true,
    //               placeholder: 'linkedin',
    //               // defaultValue: user && user.linkedInUrl ? user.linkedInUrl : '',
    //               onChange: (e: any) => {
    //                 if (e.target.value === '') {
    //                 }
    //               },
    //               // disabled: cvUrl !== '',
    //             },
    //             options: {
    //               rules: [
    //                 //   { required: cvUrl === '', message: 'Please enter Linkedin URL' },
    //                 {
    //                   validator: async (_a: any, value: string) => {
    //                     if (value === null || value === '' || value === undefined) {
    //                       return;
    //                     }
    //                     const pattern = new RegExp(
    //                       '^(https?:\\/\\/)?((www|\\w\\w)\\.)?linkedin.com\\/((in\\/[^/]+/?)|(pub\\/[^\\/]+/((\\w|\\d)+\\/?){3}))$',
    //                       'i',
    //                     );

    //                     if (!value.match(pattern)) {
    //                       throw Error('Invalid Linkedin URL');
    //                     } else {
    //                     }
    //                   },
    //                 },
    //               ],
    //             },
    //           },
    //         ]}
    //       />
    //     </Form.Form>
    //   </div>
    // </ResponsiveModal>

    //    <ResponsiveModal
    //       //   title={'Request Demo'}
    //       open={visible}
    //       footer={null}
    //     //   onOk={() => {
    //     //     // submit({ quickcvUrl: cvUrl });
    //     //   }}
    //     //   confirmLoading={loading}
    //     //   okText={'Submit Now'}
    //     //   cancelText={ 'Cancel'}
    //       onCancel={() => {
    //         setVisible(false), setError(undefined);
    //       }}
    //       >
    //       <div>Image here</div>
    //       <div>form here</div>
    //       <Space size={20} className={'fullwidth'} direction={'vertical'}>
    //         {/* {user?.linkedInUrl && (
    //             <>
    //               <TextBlock>
    //                 Hey! We noticed you have included your <TextSpan primary>LinkedIn profile</TextSpan>.
    //               </TextBlock>
    //               <TextBlock>
    //                 We can complete your <TextSpan primary>Careers360 profile</TextSpan> using your
    //                 LinkedIn profile. Interested?
    //               </TextBlock>
    //             </>
    //           )} */}
    //         <>
    //           <TextBlock>
    //             Share your <TextSpan primary>LinkedIn profile or Resume</TextSpan> with us and we will
    //             do the work for you!
    //           </TextBlock>
    //           <Form.Form
    //             form={form}
    //             layout={'vertical'}
    //             onFinish={submit}
    //             initialValues={{ linkedInUrl: user?.linkedInUrl }}>
    //             <SchemaFormItems
    //               schema={[
    //                 {
    //                   id: 'linkedInUrl',
    //                   name: 'LinkedIn Url',
    //                   type: 'url',
    //                   props: {
    //                     linkedin: true,
    //                     placeholder: 'linkedin',
    //                     // defaultValue: user && user.linkedInUrl ? user.linkedInUrl : '',
    //                     onChange: (e: any) => {
    //                       if (e.target.value === '') {
    //                       }
    //                     },
    //                     // disabled: cvUrl !== '',
    //                   },
    //                   options: {
    //                     rules: [
    //                       //   { required: cvUrl === '', message: 'Please enter Linkedin URL' },
    //                       {
    //                         validator: async (_a: any, value: string) => {
    //                           if (value === null || value === '' || value === undefined) {
    //                             return;
    //                           }
    //                           const pattern = new RegExp(
    //                             '^(https?:\\/\\/)?((www|\\w\\w)\\.)?linkedin.com\\/((in\\/[^/]+/?)|(pub\\/[^\\/]+/((\\w|\\d)+\\/?){3}))$',
    //                             'i',
    //                           );

    //                           if (!value.match(pattern)) {
    //                             throw Error('Invalid Linkedin URL');
    //                           } else {
    //                           }
    //                         },
    //                       },
    //                     ],
    //                   },
    //                 },
    //               ]}
    //             />
    //           </Form.Form>
    //         </>
    //         {/* )} */}
    //       </Space>
    //     </ResponsiveModal>
  );
};

// export const userequestDemoModal = () => useRef<RequestDemoInstance>(null);

export default React.forwardRef<RequestDemoInstance, Props>(RequestDemoModal);
